module.exports = __webpack_public_path__ + "img/change-password.a1e6c175.png";